import { render, staticRenderFns } from "./AssociarDocumentoDespesaModal.vue?vue&type=template&id=b04488e2"
import script from "./AssociarDocumentoDespesaModal.vue?vue&type=script&lang=js"
export * from "./AssociarDocumentoDespesaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports